import { connect } from 'react-redux';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectTotalProducts } from 'src/redux/products/selectors/selectors';
import { selectActiveFacets } from 'src/redux/productsQuery/selectors/selectors';
import { CategoryListing } from './CategoryListing';

const mapStateToProps = (state: ReduxApplicationState) => {
  const showProductsList = selectTotalProducts(state) > 0 || selectActiveFacets(state).length > 0;

  return {
    pageLiveRegionText: state.accessibility.statusMessage,
    products: state.products,
    showProductsList,
  };
};

export const CategoryListingContainer = connect(mapStateToProps)(CategoryListing);
